export default __webpack_public_path__ + "static/modal-background-menstruacion-7af785535e9247b8b4896cf3e908284d.png";